import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { ToastContainer, toast } from "react-toastify";
import { CONFIG } from "../../config/constant";
import "./index.scss";
import logo from "../../assets/images/logo.svg";


const ForgetPassword = (props) => {
  const [email, setEmail] = useState("");
  const [commonError, setCommonError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const regex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  const cookies = new Cookies();
  const navigate = useNavigate();

  useEffect(() => { }, [])

  function goToLogin() {
    navigate("/login");
  }

  function isValidEmail() {
    if (!email) {
      setCommonError("Email required");
      return false;
    }
    if (!email.match(regex)) {
      setCommonError("Invalid Email");
      return false;
    }
    return true;
  }


  async function Forget() {
    if (!isValidEmail()) {
      return;
    }

    if (email) {
      const data = { email: email.toLowerCase() };
      const url = CONFIG.BASE_URL + "auth/forget-password";
      let response = await fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (response && response.status === 200) {
        let data = await response.json();
        setSuccessMessage(data.message);
        // setTimeout(()=>{
        //   setEmail('');
        //   setSuccessMessage('');
        // },2000);
      } else {
        response = await response.json();
        toast(response.message || response.error_message);
        setCommonError(response.message || response.error_message);
      }
    }
  }

  return (
    <Fragment>
      <div className="forget-page">
        <div className="content">
          <img src={logo} />
          <div className="content-section">
            <h2 className="title"> Forgot Password</h2>
            <form
              onSubmit={() => {
                return;
              }}
            >
              <div className="input-wrapper">
                <label className="label">Email</label>
                <input
                  type="text"
                  placeholder="Email *"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setCommonError("");
                    setSuccessMessage("");
                  }}
                />
              </div>
              {successMessage?<div className="success-message">{successMessage}</div>:null}
              {commonError?<div className="common-error">{commonError}</div>:null}
              <input className="signup-btn" type="button" onClick={Forget} value="Forgot" />
              <div className="create-account">
                Back to
                <span onClick={goToLogin}>Login</span>
              </div>{" "}
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default ForgetPassword;
